import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import userImage from "../../components/profile.png";
import { Skeleton } from "../../components/Skeleton";

function Userprofile() {
  const [userObject, setUserObject] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuthContext();

  useEffect(() => {
    let mounted = true;

    async function fetchUser() {
      try {
        setLoading(true);
        const res = await axios.get("/api/user/username", {
          headers: { accessToken: user.token },
        });
        if (mounted) setUserObject(res.data.user);
      } catch (e) {
        if (mounted) setUserObject(null);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (user?.token) fetchUser();

    return () => (mounted = false);
  }, [user?.token]);

  return (
    <div className="card ds-card h-100 w-100">
      <div className="card-body p-4">

        {/* Header */}
        <div className="d-flex align-items-center gap-3">
          <img
            src={userImage}
            alt="User"
            width={70}
            height={70}
            style={{
              borderRadius: 16,
              objectFit: "cover",
              border: "2px solid #eee",
            }}
          />

          <div className="flex-grow-1">
            <div className="text-muted" style={{ fontSize: 13 }}>
              Profile Overview
            </div>

            {loading ? (
              <>
                <Skeleton width={180} height={22} className="mb-2" />
                <Skeleton width={110} height={14} />
              </>
            ) : (
              <>
                <h4 className="mb-0 fw-bold">
                  {userObject?.name || "—"}
                </h4>
                <div className="text-muted">@{userObject?.username || "—"}</div>
              </>
            )}
          </div>
        </div>

        <hr className="my-4" />

        {/* Info */}
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <div className="text-muted" style={{ fontSize: 12 }}>
              Email
            </div>
            <div className="fw-semibold">
              {loading ? <Skeleton width="70%" height={16} /> : userObject?.email || "—"}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="text-muted" style={{ fontSize: 12 }}>
              Phone Number
            </div>
            <div className="fw-semibold">
              {loading ? <Skeleton width="50%" height={16} /> : userObject?.phoneNumber || "—"}
            </div>
          </div>
        </div>

        <hr className="my-4" />

        {/* Footer */}
        <div className="text-muted" style={{ fontSize: 13 }}>
          You can manage leads in <b>msmart</b> or continue learning in the{" "}
          <b>Training Centre</b>.
        </div>
      </div>
    </div>
  );
}

export default Userprofile;
